import { Action } from '@ngrx/store';

export const GET_CARDS = '[payment] get cards';
export const GET_CARDS_SUCCESS = '[payment] get cards success';
export const GET_CARDS_FAILED = '[payment] get cards failed';
export const SET_DEFAULT_CARD = '[payment] set default card';
export const SET_CARDS_INIT = '[payment] set empty card store';

export class GetCards implements Action {
  public readonly type = GET_CARDS;
  public constructor() { }
}

export class GetCardsSuccess implements Action {
  public readonly type = GET_CARDS_SUCCESS;
  public constructor(public payload: any[]) { }
}

export class GetCardsFailed implements Action {
  public readonly type = GET_CARDS_FAILED;
  public constructor(public payload: any) { }
}

export class SetInitialPay implements Action {
  public readonly type = SET_CARDS_INIT;
  public constructor(public payload?: any) { }
}

export class SetDefaultCard implements Action {
  public readonly type = SET_DEFAULT_CARD;
  public constructor(public payload: string) { }
}

export type All
  = GetCards
  | GetCardsSuccess
  | GetCardsFailed
  | SetInitialPay
  | SetDefaultCard;


// WEBPACK FOOTER //
// ./src/ngrx/actions/payment.actions.ts